function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.398 12.335l7.824-9.454H4.9V1h10.082v1.455l-7.925 9.63h8.276v1.88H4.398v-1.63z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.274 33.892l11.684-14.118H44.023v-2.809h15.055v2.172L47.244 33.518h12.358v2.809H43.274v-2.434z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.398 61.292l15.162-18.32H5.37v-3.645h19.535v2.818L9.55 60.805h16.036v3.645H4.398v-3.158z",
  fill: "currentColor"
});

var SvgZzz = function SvgZzz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 65",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjUiIHZpZXdCb3g9IjAgMCA2NCA2NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMzk3ODYgMTIuMzM1MkwxMi4yMjIxIDIuODgwODRINC44OTk0MVYxSDE0Ljk4MDdWMi40NTQ1Mkw3LjA1NjExIDEyLjA4NDRIMTUuMzMxOFYxMy45NjUySDQuMzk3ODZWMTIuMzM1MloiIGZpbGw9ImJsYWNrIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjAuMyIvPgo8cGF0aCBkPSJNNDMuMjc0MSAzMy44OTI1TDU0Ljk1ODQgMTkuNzc0SDQ0LjAyMzFWMTYuOTY1Mkg1OS4wNzc4VjE5LjEzNzNMNDcuMjQzOCAzMy41MThINTkuNjAyMVYzNi4zMjY3SDQzLjI3NDFWMzMuODkyNVoiIGZpbGw9ImJsYWNrIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjAuMjUiLz4KPHBhdGggZD0iTTQuMzk3ODYgNjEuMjkxOEwxOS41NTk2IDQyLjk3MTNINS4zNjk3NlYzOS4zMjY3SDI0LjkwNTFWNDIuMTQ1Mkw5LjU0ODk2IDYwLjgwNThIMjUuNTg1NFY2NC40NTA0SDQuMzk3ODZWNjEuMjkxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgZzz as ReactComponent };